import React from "react";

const CopyIcon = (props) => {
	return (
		<svg
			width="24"
			height="25"
			viewBox="0 0 24 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M7 6.5V7.5H6C4.34315 7.5 3 8.84315 3 10.5V18.5C3 20.1569 4.34315 21.5 6 21.5H14C15.6569 21.5 17 20.1569 17 18.5V17.5H18C19.6569 17.5 21 16.1569 21 14.5V6.5C21 4.84315 19.6569 3.5 18 3.5H10C8.34315 3.5 7 4.84315 7 6.5ZM17 16.5H18C19.1046 16.5 20 15.6046 20 14.5V6.5C20 5.39543 19.1046 4.5 18 4.5H10C8.89543 4.5 8 5.39543 8 6.5V7.5H9H14C15.6569 7.5 17 8.84315 17 10.5V15.5V16.5ZM14 8.5C15.1046 8.5 16 9.39543 16 10.5V16.5V17.5V18.5C16 19.6046 15.1046 20.5 14 20.5H6C4.89543 20.5 4 19.6046 4 18.5V10.5C4 9.39543 4.89543 8.5 6 8.5H7H8H14Z"
				fill="#EFF0F6"
			/>
		</svg>
	);
};

export default CopyIcon;
